import { render } from "./UIUXEducation.vue?vue&type=template&id=92395b9a"
import script from "./UIUXEducation.vue?vue&type=script&lang=js"
export * from "./UIUXEducation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__